import { render, staticRenderFns } from "./remainingProblems.vue?vue&type=template&id=265bcdf2&scoped=true"
import script from "./remainingProblems.vue?vue&type=script&lang=js"
export * from "./remainingProblems.vue?vue&type=script&lang=js"
import style0 from "./remainingProblems.vue?vue&type=style&index=0&id=265bcdf2&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265bcdf2",
  null
  
)

export default component.exports